import { render, staticRenderFns } from "./input-checkbox-brand.vue?vue&type=template&id=6ff150a8&"
import script from "./input-checkbox-brand.vue?vue&type=script&lang=js&"
export * from "./input-checkbox-brand.vue?vue&type=script&lang=js&"
import style0 from "./input-checkbox-brand.vue?vue&type=style&index=0&id=6ff150a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports